/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {refreshTile} from '../api'

export const useMutationRefreshTile = createReactQueryMutationHook('refreshTile', refreshTile)
